/* eslint-disable import/first */
import type { ReactNode } from 'react';
import { Redirect } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { PATH_DASHBOARD, PATH_SHARE_LINK } from '../routes/paths';
import LoadingScreen from '../components/LoadingScreen';
import useSearchQuery from 'src/hooks/useSearchQuery';
import QueryString from 'qs';
import { getTrustedLoginRedirectPath } from 'src/utils/loginRedirect';

type GuestProtectProps = {
  children?: ReactNode;
};

export default function GuestProtect({ children }: GuestProtectProps) {
  const { isLoading, isAuthenticated } = useAuth();
  const query = useSearchQuery() as any;

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (isAuthenticated) {
    if (query.share) {
      delete query.share;
      return (
        <Redirect to={PATH_SHARE_LINK + '?' + QueryString.stringify(query)} />
      );
    }

    // An already-signed-in user following an emailed link still has a
    // destination to honour; don't strand them on the dashboard root.
    const redirectPath = getTrustedLoginRedirectPath(query.redirect);
    if (redirectPath) {
      return <Redirect to={redirectPath} />;
    }

    return <Redirect to={PATH_DASHBOARD.root} />;
  }

  return <>{children}</>;
}
